import React, { useContext, useState } from "react";
import { RootContext } from "../../RootContextProvider";
import "./Appearance.css";
import EditThemeStyle from "../editThemeStyle/EditThemeStyle";
import PremiumTheme from "../Billing/PremiumTheme";
import ModalUpgradeLinks from "../Locker/ModalUpgradeLinks";
import ThemeComponent from "./ThemeComponent";
import ThemeComponentPremium from "./ThemeComponentPremium";
import confettisPreview from "../../assets/themes/confettis-preview.svg";
import darkPreview from "../../assets/themes/dark-preview.svg";
import donutsPreview from "../../assets/themes/donuts-preview.svg";
import pizzaPreview from "../../assets/themes/pizza-preview.svg";
import sunsetPreview from "../../assets/themes/sunset-preview.svg";
import starryPreview from "../../assets/themes/starry-preview.svg";
import caraibesPreview from "../../assets/themes/caraibes-preview.svg";
import cartoonPreview from "../../assets/themes/cartoon-preview.svg";
import fushiaPreview from "../../assets/themes/fushia-preview.svg";
import instaPreview from "../../assets/themes/insta-preview.svg";
import formesPreview from "../../assets/themes/formes-preview.svg";
import bioPreview from "../../assets/themes/bio-preview.svg";
import rosePreview from "../../assets/themes/rose-preview.svg";

const AppearanceSettings = ({
  pageDetails,
  updateTheme,
  updateThemeColor,
  updateThemeBackgroundSetting,
  updateBBGC,
  updateBBR,
  updateBTC,
  displayCustom,
  refreshContextProvider,
}) => {
  const { account } = useContext(RootContext);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  return (
    <div className="main-container appearance-settings">
      <div className="primary-title">Apparence</div>
      <div className="block-container">
        <div className="secondary-title">Thèmes prédéfinis</div>
        <div className="block-section">
          <div className="grid-themes">
            <ThemeComponent
              updateTheme={updateTheme}
              pageDetails={pageDetails}
              themeClass="dark"
              themeName="Dark"
              themeFontColor="#FFF"
              account={account}
              themePreview={darkPreview}
            />
            <ThemeComponent
              updateTheme={updateTheme}
              pageDetails={pageDetails}
              themeClass="caraibe"
              themeName="Caraïbes"
              themeFontColor="#FFF"
              account={account}
              themePreview={caraibesPreview}
            />
            <ThemeComponent
              updateTheme={updateTheme}
              pageDetails={pageDetails}
              themeClass="rose"
              themeName="Rose"
              themeFontColor="#000000"
              account={account}
              themePreview={rosePreview}
            />
            <ThemeComponentPremium
              updateTheme={updateTheme}
              pageDetails={pageDetails}
              themeClass="starry"
              themeName="Starry"
              themeFontColor="#FFF"
              account={account}
              setShowUpgradeModal={setShowUpgradeModal}
              themePreview={starryPreview}
            />
            {/* <ThemeComponent
              updateTheme={updateTheme}
              pageDetails={pageDetails}
              themeClass="fushia"
              themeName="Fushia"
              themeFontColor="#000000"
              account={account}
            /> */}
            <ThemeComponentPremium
              updateTheme={updateTheme}
              pageDetails={pageDetails}
              themeClass="pizza"
              themeName="Pizza"
              themeFontColor="#000000"
              account={account}
              setShowUpgradeModal={setShowUpgradeModal}
              themePreview={pizzaPreview}
            />
            <ThemeComponentPremium
              updateTheme={updateTheme}
              pageDetails={pageDetails}
              themeClass="fushia"
              themeName="Fushia"
              themeFontColor="#000000"
              account={account}
              setShowUpgradeModal={setShowUpgradeModal}
              themePreview={fushiaPreview}
            />
            <ThemeComponentPremium
              updateTheme={updateTheme}
              pageDetails={pageDetails}
              themeClass="donuts"
              themeName="Donuts"
              themeFontColor="#FFF"
              account={account}
              setShowUpgradeModal={setShowUpgradeModal}
              themePreview={donutsPreview}
            />

            <ThemeComponentPremium
              updateTheme={updateTheme}
              pageDetails={pageDetails}
              themeClass="insta"
              themeName="Insta"
              themeFontColor="#FFF"
              account={account}
              setShowUpgradeModal={setShowUpgradeModal}
              themePreview={instaPreview}
            />
            {/* <ThemeComponent
              updateTheme={updateTheme}
              pageDetails={pageDetails}
              themeClass="sunset"
              themeName="Sunset"
              themeFontColor="#FFF"
              account={account}
            /> */}
            <ThemeComponentPremium
              updateTheme={updateTheme}
              pageDetails={pageDetails}
              themeClass="sunset"
              themeName="Sunset"
              themeFontColor="#FFF"
              account={account}
              setShowUpgradeModal={setShowUpgradeModal}
              themePreview={sunsetPreview}
            />
            {/* <ThemeComponent
              updateTheme={updateTheme}
              pageDetails={pageDetails}
              themeClass="bio"
              themeName="Bio"
              themeFontColor="#FFF"
              account={account}
            /> */}
            <ThemeComponentPremium
              updateTheme={updateTheme}
              pageDetails={pageDetails}
              themeClass="bio"
              themeName="Bio"
              themeFontColor="#FFF"
              account={account}
              setShowUpgradeModal={setShowUpgradeModal}
              themePreview={bioPreview}
            />
            <ThemeComponentPremium
              updateTheme={updateTheme}
              pageDetails={pageDetails}
              themeClass="cartoon"
              themeName="Cartoon"
              themeFontColor="#000000"
              account={account}
              setShowUpgradeModal={setShowUpgradeModal}
              themePreview={cartoonPreview}
            />
            <ThemeComponentPremium
              updateTheme={updateTheme}
              pageDetails={pageDetails}
              themeClass="confettis"
              themeName="Confettis"
              themeFontColor="#000000"
              account={account}
              setShowUpgradeModal={setShowUpgradeModal}
              themePreview={confettisPreview}
            />
            <ThemeComponentPremium
              updateTheme={updateTheme}
              pageDetails={pageDetails}
              themeClass="formes"
              themeName="Formes"
              themeFontColor="#0c134e"
              account={account}
              setShowUpgradeModal={setShowUpgradeModal}
              themePreview={formesPreview}
            />
            {/* <ThemeComponentPremium
              updateTheme={updateTheme}
              pageDetails={pageDetails}
              themeClass="perso"
              themeName="Custom"
              themeFontColor=""
              account={account}
              setShowUpgradeModal={setShowUpgradeModal}
            /> */}

            <div
              className="theme"
              onClick={
                account.IsPaying
                  ? () => {
                      updateTheme("none");
                    }
                  : () => {
                      setShowUpgradeModal(true);
                    }
              }
            >
              {" "}
              <div
                className={`${
                  pageDetails.HasCustomTheme
                    ? "theme-style perso selected"
                    : "theme-style perso"
                }`}
              >
                {" "}
                Personnalisez votre thème{" "}
                {!account.IsPaying ? (
                  <div className="premium-theme">
                    <PremiumTheme fontSize="12px" height="30px" />
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="theme-name">Custom</div>
            </div>
          </div>
        </div>
      </div>
      <div className="block-container">
        <div className="secondary-title">
          Thème personnalisé{" "}
          <span className="tiny-title">(thème Custom seulement)</span>
        </div>
        {account.IsPaying ? (
          <div className="block-section">
            <EditThemeStyle
              disabled={pageDetails.HasCustomTheme ? false : true}
              pageDetails={pageDetails}
              updateThemeColor={updateThemeColor}
              updateBTC={updateBTC}
              updateBBGC={updateBBGC}
              updateBBR={updateBBR}
              updateThemeBackgroundSetting={updateThemeBackgroundSetting}
              refreshContextProvider={refreshContextProvider}
            />
          </div>
        ) : (
          <div
            className="block-section"
            onClick={() => {
              setShowUpgradeModal(true);
            }}
          >
            <EditThemeStyle
              disabled={pageDetails.HasCustomTheme ? false : true}
              pageDetails={pageDetails}
              updateThemeColor={updateThemeColor}
              updateBTC={updateBTC}
              updateBBGC={updateBBGC}
              updateBBR={updateBBR}
              updateThemeBackgroundSetting={updateThemeBackgroundSetting}
              refreshContextProvider={refreshContextProvider}
            />
          </div>
        )}
      </div>
      <ModalUpgradeLinks
        subtitle="Débloquez tous les thèmes en passant premium."
        showUpgradeModal={showUpgradeModal}
        setShowUpgradeModal={setShowUpgradeModal}
      />
    </div>
  );
};

export default AppearanceSettings;
